/**
 * Channel Type Enums
 */

/** Channel type enum from backend */
export enum ChannelType {
  Airbnb = 1,
  Gathern = 2,
  Booking = 3,
  // Future channel types (reserved for API compatibility)
  Channel4 = 4,
  Channel5 = 5,
  Channel6 = 6,
  Channel7 = 7,
}

/** Channel name type */
export type ChannelName = 'airbnb' | 'booking' | 'gathern';

/** Channel connection status */
export type ChannelStatus = 'connected' | 'not_connected' | 'connecting' | 'error';

/** Channel connection status (alias) */
export type ChannelConnectionStatus = 'connected' | 'not_connected' | 'connecting' | 'error';

/** Connection step type */
export type ConnectionStep = 'connect' | 'success' | 'import' | 'progress';

/** Unit mapping status */
export type UnitMappingStatus = 'mapped' | 'not_mapped';

/** Unit status type */
export type UnitStatus = 'synced' | 'not_synced' | 'failed';

/** Booking unit type - single unit or multi-unit (hotel) */
export type BookingUnitType = 'single' | 'multi';

/** Sync status enum from backend - matches Swagger SyncStatus enum [0-6] */
export enum SyncStatus {
  NotSynced = 0,
  Synced = 1,
  InProgress = 2,
  Failed = 3,
  Pending = 4,
  Imported = 5,
  Disconnected = 6,
}

/** Color mapping for sync status */
export const SYNC_STATUS_COLORS: Record<SyncStatus, { bg: string; text: string }> = {
  [SyncStatus.NotSynced]: { bg: '#F3F4F6', text: '#6B7280' },
  [SyncStatus.Synced]: { bg: '#ECFDF5', text: '#059669' },
  [SyncStatus.InProgress]: { bg: '#FEF3C7', text: '#D97706' },
  [SyncStatus.Failed]: { bg: '#FEE2E2', text: '#DC2626' },
  [SyncStatus.Pending]: { bg: '#E0E7FF', text: '#4F46E5' },
  [SyncStatus.Imported]: { bg: '#5B2FF91A', text: '#5B2FF9' },
  [SyncStatus.Disconnected]: { bg: '#FEE2E2', text: '#DC2626' },
};
